import numeral from 'numeral'

export default {
  methods: {
    isWholeNumber(num) {
      return Number.isInteger(num);
    },
    decimalize(num) {
      if (isNaN(num)) {
        return 0;
      }
      let number = numeral(num);
      if (this.isWholeNumber(num)) {
        return number.format('0');
      }
      return number.format('0.0');
    },
    humanize(str) {
      let frags = str.split("_");
      for (let i = 0; i < frags.length; i++) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
      }
      return frags.join(" ");
    },
    getUnit(key) {
      switch (key) {
        case "calories":
          return "kcal";
        case "protein":
          return "g";
        case "carbohydrate":
          return "g";
        case "sugar":
          return "g";
        case "fat":
          return "g";
        case "saturated_fat":
          return "g";
        case "monounsaturated_fat":
          return "g";
        case "polyunsaturated_fat":
          return "g";
        case "cholesterol":
          return "g";
        case "fibre":
          return "g";
        case "sodium":
          return "mg";
        case "potassium":
          return "mg";
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/FoodDiaryNutritionMixin/index.js